import {ColDef} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import AGGridFieldIdCellRenderer from "@/components/inputs/AGGridFieldIdCellRenderer.vue";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;
import AGGridSuggestionProviderEditor from "@/components/inputs/AGGridSuggestionProviderEditor.vue";

export default class AGGridEditViewFieldIdColumn extends AbsAGGridEditViewColumn
{
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = AGGridFieldIdCellRenderer
    colDef.cellRendererParams = {
      handler: () => this.handler
    }
    colDef.autoHeight = true;
    if (this.handler.presenter.doesFieldHasSuggestionProvider(this.columnMetadata)) {
      colDef.cellEditor = AGGridSuggestionProviderEditor;
      colDef.cellEditorParams = {
        columnMetadata: this.columnMetadata,
        presenter: () => this.handler.presenter
      };
    }
    return [colDef];
  }
}
